import { ca } from '@cian/analytics';
import { IRecommendationNewbuildingInfrastructure } from '../../../types/map';

export function trackSimilarNewbuildingInfrastructureOpen(newbuilding: IRecommendationNewbuildingInfrastructure) {
  const { modelVersion, newbuildingId } = newbuilding;

  ca('eventSite', {
    action: 'click',
    category: 'Infrastructure',
    label: 'similar_newbuilding',
    modelVersion,
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        PageTypeJK: 'Normal',
        newbuildingId,
      },
    },
    useLastProducts: true,
  });
}
